module.exports = __webpack_public_path__ + "img/item13.346b6769.png";